import * as React from 'react';
import { Chip, makeStyles, ChipProps } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  chip: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.getContrastText(theme.palette.error.main),
    '& .MuiChip-deleteIcon': {
      color: theme.palette.getContrastText(theme.palette.error.main)
    }
  },
  newChip: {
    backgroundColor: theme.palette.aegis.semantic.error.muted,
    border: `1px solid ${theme.palette.aegis.semantic.error.base}`
  },
  deleteIcon: {
    fill: theme.palette.aegis.semantic.message.dark
  }
}));

export default function ErrorChip({ className, ...props }: ChipProps) {
  const classes = useStyles();
  return <Chip className={clsx(classes.chip, className)} {...props} />;
}

export function NewErrorChip({ className, ...props }: ChipProps) {
  const classes = useStyles();
  return (
    <Chip
      className={clsx(classes.newChip, className)}
      {...props}
      classes={{
        deleteIcon: classes.deleteIcon
      }}
    />
  );
}
